module.exports = __webpack_public_path__ + "static/media/record-nav-left-active.437a6c5f.svg";